import mockData from "../../data/mock.json";
const state = () => ({
  basicPage: null,
  content: null,
  activityCount: 0,
  jxCount: 0,
  weekCount: null,
  fortnightCount: null,
  activeJurisdictions: null,
  mapData: null,
  regEventsByQuarter: null,
  updatedContent: mockData.updatedContent,
  horizonScanningList: null,
  horizonScanningArticle: null,
  horizonScanningActivity: null,
  filters: null,
  chartDataAllQuarter: null,
  totalRegBenchmark: null,
  impactIndex: mockData.impactIndex,
  avgRegBenchmark: null,
  regEventsDocumentTypes: null,
  regEventsSpecialism: null,
  chartDocumentType: null,
  recentUpdates: null,
  recentUpdatesCount: null,
  relatedContent: null,
  relatedGuides: null,
  deadlines: null,
  calendarMonth: null,
  effectiveDeadlines: null,
  calendarYear: null,
  monthlyEffectiveDates: null,
  monthlyRespondDates: null,
  applicableDeadlines: null,
  reportingDeadlines: null,
  monthlyApplicableDates: null,
  monthlyReportingDates: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  setArticleData(state, data) {
    if (data.data.horizonScanningArticle.effectiveDate) {
      data.data.horizonScanningArticle.effectiveDate.sort((a, b) => new Date(a) - new Date(b));
    }
    state[data.label] = data.data;
  },
  setYearData(state, data) {
    const sortArray = [];

    for (let i = 0; i < 12; i++) {
      sortArray.push({ count: 0, date: "" });
    }

    data.data.forEach((item) => {
      let index = 0;
      const convertDate = new Date(item.date);
      index = parseInt(convertDate.getMonth());
      sortArray[index].count = item.count || "0";
      sortArray[index].effectiveCount = item.effectiveCount || "0";
      sortArray[index].responseCount = item.responseCount || "0";
      sortArray[index].applicableCount = item.applicableCount || "0";
      sortArray[index].reportingCount = item.reportingCount || "0";

      sortArray[index].date = item.date;
    });

    state[data.label] = sortArray;
  },
  appendData(state, data) {
    state[data.label].push(data.data);
  },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
      });
  },
  async getViewData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
